module.exports = __webpack_public_path__ + "img/power-100.61693efd.png";